import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment-timezone'
import { MdOutlineAssignment, MdOutlineAttachFile } from 'react-icons/md'
import { GET_REGISTRATION_RESPONSE } from '../../repository/registration_form_repo'

// Long answers take the full row of the grid
const WIDE_TYPES = ['textarea', 'file']

const formatAnswer = (answer, t) => {
  const { value } = answer
  if (value === null || value === undefined || value === '') return <span className="registration_answers_empty">-</span>
  if (answer.type === 'file' && value?.url)
    return (
      <a href={value.url} target="_blank" rel="noreferrer" className="registration_answers_link">
        <MdOutlineAttachFile size={16} /> {value.name || t('registrationForm.viewFile')}
      </a>
    )
  if (answer.type === 'email') return <a href={`mailto:${value}`} className="registration_answers_link">{value}</a>
  if (answer.type === 'phone') return <a href={`tel:${value}`} className="registration_answers_link">{value}</a>
  if (Array.isArray(value))
    return (
      <div className="d-flex flex-wrap gap-1">
        {value.map((option) => <span key={option} className="registration_answers_chip">{option}</span>)}
      </div>
    )
  if (typeof value === 'boolean') return value ? t('registrationForm.yes') : t('registrationForm.no')
  return String(value)
}

// Read-only registration form answers a client submitted with one event booking
const RegistrationResponseView = ({ registrationResponseId }) => {
  const { t } = useTranslation()
  const [response, setResponse] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    setLoading(true)
    GET_REGISTRATION_RESPONSE(registrationResponseId)
      .then((res) => active && setResponse(res?.data || null))
      .catch(() => active && setResponse(null))
      .finally(() => active && setLoading(false))
    return () => { active = false }
  }, [registrationResponseId])

  if (loading) return <div className="registration_answers_state">{t('registrationForm.loadingAnswers')}</div>
  if (!response?.responses?.length) return <div className="registration_answers_state">{t('registrationForm.noAnswers')}</div>

  // The same answers are saved for every ticket type that uses the form; show each form once
  const shown = new Set()
  return (
    <div className="registration_answers">
      {response.responses
        .filter((item) => {
          const key = item.registrationFormId?.toString()
          if (shown.has(key)) return false
          shown.add(key)
          return true
        })
        .map((item) => (
          <div key={item.ticketId} className="registration_answers_card">
            <div className="registration_answers_header">
              <div className="registration_answers_icon">
                <MdOutlineAssignment size={22} />
              </div>
              <div className="flex-fill">
                <h6 className="registration_answers_title">{item.formName}</h6>
                <div className="registration_answers_meta">
                  {t('registrationForm.answersCount', { count: item.answers?.length || 0 })}
                  {response.createdAt && ` · ${t('registrationForm.submittedOn')} ${moment(response.createdAt).format('MMM DD, YYYY, hh:mm A')}`}
                </div>
              </div>
            </div>
            <div className="registration_answers_grid">
              {item.answers?.map((answer) => (
                <div
                  key={answer.fieldId}
                  className={`registration_answers_item${WIDE_TYPES.includes(answer.type) || Array.isArray(answer.value) ? ' registration_answers_item_wide' : ''}`}
                >
                  <div className="registration_answers_label">{answer.label}</div>
                  <div className="registration_answers_value">{formatAnswer(answer, t)}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  )
}

export default RegistrationResponseView
